import { useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';

import GetReasonCodesQuery from '@/graphql/contracts/getReasonCodes.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetReasonCodes, GetReasonCodesVariables } from '@/graphql/contracts/_generated_/getReasonCodes.query';
import { notificationService } from '@/services/notification/notification.client';

export function useGetReasonCodes() {
  const [_getReasonCodes, { data, loading }] = useLazyQuery<GetReasonCodes, GetReasonCodesVariables>(
    GetReasonCodesQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
    }
  );

  const getReasonCodes = useCallback((type: string, includeDisabled: boolean = false) => {
    _getReasonCodes({
      variables: {
        type,
        includeDisabled,
      }
    });
  }, [_getReasonCodes]);

  return {
    getReasonCodes,
    isLoading: loading,
    reasonCodes: data?.reasonCodes ?? [],
  } as const;
}
